import React, { useState, useEffect,Fragment } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid
} from "@material-ui/core";
import { addExpenseDialogCss } from './VehicleDialogCss';
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { connect } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import { addVendorExpense,addExpenseV1,editExpenseV1 } from '../../../store/actions/tripActionCreator';
import S3Uploader from '../s3Uploader/s3Uploader';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import DriverNameSelect from '../DriverDialogs/DriverNameSelect';
import { ExpenseTypeReceiptIcon,AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import * as logger from '../../../logger';
import { getTripDateFilterValues,isEmpty, numberWithCommas, replaceCommas, checkNumberOnly } from '../../../utils/utils';
import { updateVehicle3, singleTruck, PandL, Expenses, DriverExpenseType, AddExpenseTypeDriver, UpdateExpenseDetails, DeletePhotoAttachments } from '../../../store/actions/vehicleActionCreator';
import NotesIcon from '@material-ui/icons/Notes';
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { Waypoint } from "react-waypoint";
import AddShop from '../../pages/Shops/AddShop';
import { shopListForSelection } from '../../../store/actions/userActionCreators';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const AddDriverExpenseDialog = ({ open, onClose, vehicle, user, dispatchUpdateExpenseDetails, dispatchPhotoAttachmentDelete, onConfirm, dispatchAddExpenseTypeDriver, dispatchUpdateVehicleNew, dispatchGetSingleTruck, dispatchGetPandL, dispatchGetTripExpenses, dispatchDriverExpenseType, dispatchAddExpenseTypeMaintenance, dispacthAddExpenses, edit, driverExpenseData,
    dispatchAddExpenseV1,
    dispatchEditExpenseV1,
    dispatchGetShopList,
     expenseId }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [formError, setFormError] = React.useState(false);
    const [addDriverDialog, setAddDriverDialog] = useState(false);
    const [paidByDriverValue, setPaidByDriverValue] = useState(false);
    const [addExpensePhoto, setAddExpensePhoto] = useState(driverExpenseData && driverExpenseData.attachments ? driverExpenseData.attachments : []);
    const [driverExpenseType, setDriverExpenseType] = useState([]);
    const [expenseTypeValue, setExpenseTypeValue] = useState({ expenseName: driverExpenseData && driverExpenseData.expenseName ? driverExpenseData.expenseName : "" });
    const [expenseTypeOpen, setExpenseTypeOpen] = useState(false);
    const [driverNameValue, setDriverNameValue] = useState("");
    const [amountValue, setAmountValue] = useState("");

    const [expensePaymentMethod, setExpensePaymentMethod] = React.useState('cash');
    const [expenseTransactionId, setExpenseTransactionId] = React.useState('');
    const [shopsListData, setShopsListData] = React.useState(null);
    const [shops, setShops] = React.useState([]);
    const [expenseShop, setExpenseShop] = React.useState(null);
    const [shopInputValue, setShopInputValue] = React.useState('');
    const [currentPageNo,setCurrentPageNo]  = useState(1);
    const [currentPageSize,setCurrentPageSize]  = useState(10);
    const [addShopOpen, toggleAddShopOpen] = React.useState(false);
    const [shopDialogValue, setShopDialogValue] = React.useState({
        name: ''
    });
    const handleAddShopClose = () => {
        setShopDialogValue({
        name: '',
        });
        toggleAddShopOpen(false);
    };
    const handleShopSave = (status, response) => {
        toggleAddShopOpen(false);
        fetchShops()
        setExpenseShop(response && response.id ? response : null);
    }
    const onSearchBlur = debounce(query => {
        setCurrentPageNo(defaultPageNo)
        fetchShops(query,false)
      }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
      const fetchShops = (search,pagination)=>{
          let req = {
            pageSize:defaultPageSize,
            pageNo:defaultPageNo,
          }
          if(pagination){
            req.pageNo = currentPageNo+1
          }
          if(search){
            req.search=search;
          }
          dispatchGetShopList(req,(res)=>{
            if(res && res.status && res.status.code && res.status.code == 200 && res.response){
              setShopsListData(res.response)
              if(pagination){
                setShops([...shops,...res.response.shops])
              }else{
                setShops(res.response.shops)
              }
            }
          },()=>{

          })
    }
    useEffect(() => {
        if (driverExpenseData && driverExpenseData.id) {
            if(driverExpenseData.paymentMethod){
                setExpensePaymentMethod(driverExpenseData.paymentMethod)
            }
            if(driverExpenseData.paymentMethod && driverExpenseData.paymentMethod == 'credit' && driverExpenseData.shopId && driverExpenseData.shopName){
                setExpenseShop({
                    id:driverExpenseData.shopId,
                    name:driverExpenseData.shopName
                })
            }
            if(driverExpenseData.paymentMethod && driverExpenseData.paymentMethod == 'online' && driverExpenseData.paymentData){
                setExpenseTransactionId(driverExpenseData.paymentData)
            }
        }
    }, [open, driverExpenseData]);
    useEffect(()=>{
        let active = true;
        if(shopInputValue ===''){
          return undefined;
        }
        return()=>{
          active = false
        }
    },[shopInputValue])
    useEffect(()=>{
      if(expensePaymentMethod && expensePaymentMethod == 'credit'){
        //fetchShops()
      }
      if(expensePaymentMethod && expensePaymentMethod == 'paid_by_driver'){
        /*if (!driverVal) {
          handleDriverSelectOpen(true);
        }*/
        handlePaidByDriver()
      }
    },[expensePaymentMethod])

    let singleTruck = vehicle.singleTruck;
    let truckBook = vehicle.truckBooks;

    const filter = createFilterOptions();

    const classes = addExpenseDialogCss();


    useEffect(() => {

        dispatchDriverExpenseType(
            (data) => {
                logger.log("Driver Book", "Get vehicle expense type successfull");
                if (data.status && data.status.code == 200) {
                    setDriverExpenseType(data.response);
                }
            },
            () => {
                logger.log("Driver Book", "Get Vehicle Expense Type Failed");
            }
        );

    }, [open]);

    const initialValues = {
        paidByDriver: paidByDriverValue,
        amount: amountValue ? amountValue : driverExpenseData && driverExpenseData.amount ? numberWithCommas(driverExpenseData.amount) : "",
        expenseType: expenseTypeValue && expenseTypeValue.expenseName ? expenseTypeValue.expenseName : "",
        expenseDate: driverExpenseData && driverExpenseData.expenseDate ? new Date(driverExpenseData.expenseDate * 1000) : new Date(),
        notes: driverExpenseData && driverExpenseData.description ? driverExpenseData.description : "",
        paymentMethod:expensePaymentMethod,
        transactionId:expenseTransactionId,
        shop:expenseShop,
    }

    const handleAddExpensePhoto = (file) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.push({ s3Link: file });
        setAddExpensePhoto(newPhoto);
    }

    const handleDeleteExpensePhoto = (index, attachId) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.splice(index, 1);
        setAddExpensePhoto(newPhoto);

        if (attachId) {
            dispatchPhotoAttachmentDelete(
                expenseId,
                attachId,
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment deleted successfully");
                },
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment delete failed");
                },
            )
        }
    }

    const handlePaidByDriver = (value) => {

        setPaidByDriverValue(!paidByDriverValue);

        if (singleTruck.driverName == null) {
            setAddDriverDialog(true);
        }
    }

    const handleAddDriverDialogClose = () => {

        setAddDriverDialog(false);
        setExpensePaymentMethod('cash')
        // if (singleTruck && singleTruck.driverName) {
        //     setPaidByDriverValue(true);
        // }
        // else {
        //     setPaidByDriverValue(false);
        // }
        if (!singleTruck.driverId && !paidByDriverValue) {
            setAddDriverDialog(true);
            setDriverNameValue("");
        }
        else if (singleTruck.driverId && !paidByDriverValue) {
            setAddDriverDialog(true);
            setDriverNameValue({ name: singleTruck.driverName, id: singleTruck.driverId });
        }
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleNewExpenseType = (expenseTypeValue) => {

        let splitted = expenseTypeValue ? (expenseTypeValue.replace(/\'/g, "")).split(" ") : [];

        let value = "";

        splitted.forEach((splittedString) => {
            value += splittedString.charAt(0).toUpperCase() + splittedString.slice(1) + " ";
        });

        var expenseValue = value.trim();

        var expenseTypeData = {
            expense_type: expenseValue
        }

        dispatchAddExpenseTypeDriver(expenseTypeData,
            (data) => {
                if (data.status && data.status.code == 200) {
                    logger.log("Driver Book", "Add new expense type successfull");
                    dispatchDriverExpenseType(
                        (data) => {
                            logger.log("Driver Book", "Get vehicle expense type successfull");
                            if (data.status && data.status.code == 200) {
                                setDriverExpenseType(data.response);
                            }
                        },
                        () => {
                            logger.log("Driver Book", "Get Vehicle Expense Type Failed");
                        }
                    );
                }
            },
            () => {
                logger.log("Driver Book", "Add new expense type failed");
            }
        )

    }

    const handleAddDriverSubmit = (driverIdValue) => {

        let vehicleIdValue = singleTruck.id;

        var data = {
            driverId: driverIdValue
        }

        var dateFilterValueUtil = getTripDateFilterValues();

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";

        dispatchUpdateVehicleNew(
            vehicleIdValue,
            data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Add Driver Dialog", "Update Vehicle successfull");
                    setAddDriverDialog(false);
                    setExpensePaymentMethod('paid_by_driver')
                    dispatchGetSingleTruck(vehicleIdValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                                dispatchGetPandL(PandLdata, defaultDateFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                                            dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                                (data) => {
                                                    if (data && data.status && data.status.code == 200) {
                                                        logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");
                                                    }
                                                },
                                                () => {
                                                    logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                                },
                                            )
                                        }
                                    },
                                    () => {
                                        logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
                        }
                    );
                }
            },
            () => {
                logger.log("Add Driver Dialog", "Update Vehicle failed");
            }
        );
    }

    const validate = values => {
        const errors = {}
        if(values){
            if(errors.noValues){
              delete errors['noValues'];
            }
            if (!values.expenseType) {
                errors.expenseType = "Please select expense type."
            }
            if (!values.amount || !checkNumberOnly(replaceCommas(values.amount))) {
                errors.amount = "Please enter valid amount."
            }
            if (!values.expenseDate) {
                errors.expenseDate = "Please select expense date"
            }
            if(!values.paymentMethod){
                errors.paymentMethod = 'Please Select a Payment Mode';
            }
            if(values && values.paymentMethod && values.paymentMethod =='credit' && !values.shop){
                errors.shop = 'Please Select a shop';
            }
        }else{
            errors.noValues = "novalues"
        }

        return errors
    }

    const onSubmit = values => {

        const fleetOwnerIdValue = user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "";

        let splitted = values && values.expenseType ? (values.expenseType.replace(/\'/g, "")).split(" ") : [];
        let {
            paymentMethod,
            shop,
            transactionId
           } = values;

        let value = "";

        splitted.forEach((splittedString) => {
            value += splittedString.charAt(0).toUpperCase() + splittedString.slice(1) + " ";
        });

        var expenseValue = value.trim();

        let index = driverExpenseType.findIndex(x => x.expenseName === expenseValue);
        let expenseTypeSelectedValue = driverExpenseType && driverExpenseType[index] && driverExpenseType[index].expenseType ? driverExpenseType[index].expenseType : "";
        let expenseParentTypeValue = driverExpenseType && driverExpenseType[index] && driverExpenseType[index].expenseParentType ? driverExpenseType[index].expenseParentType : "";

        var expenseData = {
            vehicleId: singleTruck && singleTruck.id ? singleTruck.id : "",
            fleetOwnerId: fleetOwnerIdValue,
            amount: replaceCommas(values.amount),
            expenseDate: Math.round((values.expenseDate.setHours(0, 0, 0, 0) / 1000)),
            attachments: addExpensePhoto,
            expenseType: expenseTypeSelectedValue,
            expenseParentType: expenseParentTypeValue,
            description: values.note,
            paymentMethod:paymentMethod,
            paidByDriver: values.paidByDriver,
        }
        if (paymentMethod && paymentMethod == 'online' && transactionId) {
            expenseData['paymentData'] = transactionId;
        }
        if (paymentMethod && paymentMethod == 'paid_by_driver') {
            expenseData['paidByDriver'] = true;
        }
        if (paymentMethod && paymentMethod == 'credit' && shop && shop.id) {
            expenseData['shopId'] = shop.id;
          } else {
            expenseData['shopId'] = null;
          }
        /*if (values.paidByDriver) {
            expenseData.paidByDriver = values.paidByDriver;
        }*/

        if (edit) {
            dispatchEditExpenseV1(
                expenseId,
                expenseData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        logger.log("Add Fuel Expense Dialog Dweb", "Update expense successfull");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Add Fuel Expense Dialog Dweb", "Update expense failed");
                }
            );
        } else {
            dispatchAddExpenseV1(expenseData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        logger.log("Single Vehicle Add Maintenance Dialog", "Add expense successfull");
                        setDialogOpen(false);
                        onConfirm();
                        trackDwebEvent("Dweb SVP Other Expenses Expense Created Successfully", {
                            vehicle_id: data && data.response && data.response.vehicleId ? data.response.vehicleId : "",
                            vehicle_number: truckBook.vehicleNumber ? truckBook.vehicleNumber : "",
                            total_other_expense: truckBook.totalCost ? truckBook.totalCost : "",
                            expense_amount: data && data.response && data.response.amount ? data.response.amount : "",
                            expense_id: data && data.response && data.response.id ? data.response.id : "",
                        });
                    }
                },
                () => {
                    logger.log("Single Vehicle Add Maintenance Dialog", "Add expense failed");
                }
            );
        }
    }

    const handleDisplayPaidByDriver = (value) => {
        if (value) {
            let index = driverExpenseType.findIndex(x => x.expenseName === value);
            let driverCheck = driverExpenseType && driverExpenseType[index] && driverExpenseType[index].expenseParentType ? driverExpenseType[index].expenseParentType : "";
            if (driverCheck != "driver") {
                return true
            } else if (driverCheck == "driver") {
                return false
            }
        }
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: driverExpenseType && driverExpenseType.length > 0 ? true : false,
                field: (
                    <>
                        <div className={classes.titleV1} >Expense Type*</div>
                        <Autocomplete
                            classes={{
                                listbox: classes.listBoxAutoCompelete,
                                option: classes.listBoxOption,
                                input: classes.textTransformCaptialize
                            }}
                            id="select-expense-type"
                            label="Expense Type"
                            name="expenseType"
                            size="small"
                            required={true}
                            placeholder="Expense Type"
                            open={expenseTypeOpen}
                            onOpen={() => {
                                setExpenseTypeOpen(true);
                            }}
                            onClose={() => {
                                setExpenseTypeOpen(false);
                            }}
                            // value={cityName}
                            onChange={(event, newValue) => {

                                let newTypeValue = newValue ? newValue.toString() : "";

                                if (typeof newTypeValue === 'string') {

                                    // timeout to avoid instant validation of the dialog's form.
                                    setTimeout(() => {
                                        // toggleAddReasonOpen(true);
                                        setExpenseTypeValue(newValue);
                                    });
                                } else if (newValue) {
                                    // toggleAddReasonOpen(true);
                                    setExpenseTypeValue(newValue);
                                } else if (newValue === '') {
                                    // toggleAddReasonOpen(true);
                                    setExpenseTypeValue(newValue);
                                } else {
                                    setExpenseTypeValue(newValue);
                                }
                            }}
                            getOptionSelected={(option, value) => option.expenseName === value.expenseName}
                            autoHighlight
                            freeSolo
                            options={driverExpenseType ? driverExpenseType : []}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            getOptionValue={option => option.expenseName}
                            getOptionLabel={(option) => {
                                // e.g value selected with enter, right from the input
                                let value = option.expenseName ? option.expenseName.replace(/\'/g, "") : "";
                                if (typeof option === 'string') {
                                    // setExpenseTypeValue(option);
                                    return value;
                                }
                                if (option) {
                                    // setExpenseTypeValue(option);
                                    return value;
                                }
                                // setExpenseTypeValue(option);

                                return value;
                            }}
                            disableCloseOnSelect={false}
                            filterOptions={(options, params) => {

                                const filtered = filter(options, params);

                                if (params.inputValue !== '') {
                                    filtered.unshift({
                                        expenseName: `'${params.inputValue}'`,
                                    });
                                    // filtered.unshift(
                                    //     `'${params.inputValue}'`,
                                    // );
                                }

                                return filtered;

                            }}
                            renderOption={(option, params) => {
                                if (params.inputValue !== '' && option && option.expenseName && option.expenseName.toString().includes("\'")) {
                                    return (
                                        <>
                                            <div className={classes.newExpenseTypeV1} onClick={() => handleNewExpenseType(option.expenseName)}>
                                                <div className={classes.newExpenseTypeV2}>
                                                    <div>
                                                        <ExpenseTypeReceiptIcon className={classes.fontSize32} />
                                                    </div>
                                                    <div className={classes.divV6}>
                                                        <div className={classes.capitalize}>{option.expenseName}</div>
                                                        <div>Tap to add new Expense Type</div>
                                                    </div>
                                                </div>
                                                <ChevronRightIcon className={classes.cherveRightIcon} />
                                            </div>
                                        </>
                                    );
                                } else {
                                    return (
                                        <div className={classes.divExpenseName}>
                                            {option.expenseName}
                                        </div>
                                    );
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Enter Reason"
                                    placeholder="Expense Type"
                                    variant="outlined"
                                    name="expenseType"
                                    margin='normal'
                                    className={classes.divMargin}
                                />
                            )}
                            multiple={false}
                        />
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Amount Paid*</div>
                            <AmountInput
                                placeholder="Amount Paid"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setAmountValue(e.target.value)}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Expense Date*</div>
                            <DatePicker
                                disableFuture
                                name="expenseDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                // onChange={(date) => { setTripStartDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Select Date"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.marginV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            />
                        </div>
                    </>
                ),
            },
            {
              size: 12,
              visible: true,
              inline: false,
              field: (
                <>
                  {/* <div className={classes.divTripV2}>Billing Information</div> */}
                  <div className={classes.marginV2}>
                  <div className={classes.title}>Payment Mode*</div>
                  <Radios
                    //label="Payment Mode"
                    name="paymentMethod"
                    required={true}
                    formControlProps={{
                      margin: 'none',
                      className: classes.billingTypeRadio,
                      fullWidth: true
                    }}
                    formControlLabelProps={{
                      className: classes.billingTypeLabel
                    }}
                    className={classes.mtV2}
                    onChange={(e) => {setExpensePaymentMethod(e.target.value)}}
                    formLabelProps={{}}
                    radioGroupProps={{ row: true }}
                    data={[
                      { value: 'cash', label: 'Cash' },
                      { value: 'credit', label: 'Credit' },
                      { value: 'paid_by_driver', label: 'Paid By Driver' },
                      { value: 'online', label: 'Online' }
                    ]}
                  />
                  </div>
                </>
              ),
            },
            {
              size: 12,
              visible:values && values.paymentMethod && values.paymentMethod=='credit'?true:false,
              field: (<Autocomplete
                required={true}
                id="search-shop-input"
                onOpen={()=>{
                  fetchShops()
                }}
                getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                options={shops}
                autoComplete
                name="shop"
                //includeInputInList
                filterSelectedOptions
                size="small"
                //disableClearable
                value={expenseShop}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    // timeout to avoid instant validation of the dialog's form.
                    setTimeout(() => {
                      setExpenseShop('');
                      toggleAddShopOpen(true);
                      setShopDialogValue({
                        name: newValue ? newValue : "",
                      });
                    });
                  } else if (newValue && newValue.inputValue) {
                    setExpenseShop(null);
                    toggleAddShopOpen(true);
                    setShopDialogValue({
                      name: newValue.inputValue ? newValue.inputValue : "",
                    });
                  } else if (newValue && newValue.inputValue === '') {
                    setExpenseShop('');
                    toggleAddShopOpen(true);
                    setShopDialogValue({
                      name: "",
                    });
                  } else {
                    setExpenseShop(newValue && newValue.id ? newValue : null);
                  }
                }}
                filterOptions={(options, params) => {
                  let filtered =[]
                  options.forEach((item,index)=>{
                    filtered.push({
                      ...item,
                      index:index
                    })
                  });
                    filtered.unshift({
                        inputValue: params.inputValue,
                        name: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}" as Shop` : `Add New Shop`,
                        add: true
                    });
                  return filtered;
                }}
                clearOnBlur
                multiple={false}
                getOptionValue={option => option}
                getOptionLabel={(option) => {
                  // e.g value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return '';
                  }
                  if (option.inputValue || !option.id) {
                    return '';
                  }
                  return option && option.name ? option.name : ''
                }}
                onInputChange={(event, newInputValue) => {
                  setShopInputValue(newInputValue);
                  onSearchBlur(newInputValue,false)
                }}
                classes={
                    {
                      option:classes.shopOption
                    }
                  }
                textFieldProps={
                  {
                    label: "Shop",
                    placeholder: "Search and select shop",
                    variant: "outlined",
                    margin: 'normal',
                  }
                }
                renderOption={(option, { selected, inputValue }) => {
                  let matchesName, matchesNumber;
                  let partsName, partsNumber;
                  matchesName = match(option.name, inputValue);
                  partsName = parse(option.name, matchesName);
                  matchesNumber = match(option.contactNumber, inputValue);
                  partsNumber = parse(option.contactNumber, matchesNumber);

                  if (option && option.id) {
                    if (option.index == shops.length-1) {
                      return (
                        <Fragment>
                          <Waypoint
                            onEnter={() => {
                              if(!shopInputValue && shopsListData && shopsListData.maxPage && shopsListData.maxPage != currentPageNo){
                                setCurrentPageNo(currentPageNo+1)
                                fetchShops(option.inputValue,true)
                              }
                            }}
                          />
                         <div className={classes.shopListItem}>
                            {partsName.map((part, index) => {
                              return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                {part.text}
                              </span>
                              )
                            })}
                            {option.contactNumber && <>
                              <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                              {partsNumber.map((part, index) => {
                                return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                  {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                </span>
                                )
                              })}
                            </>}
                          </div>
                        </Fragment>
                      );
                    } else {
                      return (
                        <div className={classes.shopListItem}>
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        {option.contactNumber && <>
                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                          {partsNumber.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                              {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                            </span>
                            )
                          })}
                        </>}
                      </div>
                      );
                    }
                  } else {
                    return (
                      <div className={classes.shopListItem1}>
                        <AddPersonIcon className={classes.addPersonIcon} />
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ color: index == 0 ? '#0033cc' : 'black' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        <ChevronRightIcon className={classes.cherveRightIcon} />
                      </div>
                    );
                  }

                }}
                />)
            },
            {
              size: 12,
              visible: values && values.paymentMethod && values.paymentMethod=='online'?true:false,
              field: (
                <TextField
                  label={'Transaction ID'}
                  placeholder="Transaction ID"
                  name="transactionId"
                  variant="outlined"
                  size="small"
                  margin="normal"
                  onChange={(e) => { setExpenseTransactionId(e.target.value) }}
                />
              ),
            },
            {
              size: 12,
              visible: values && values.paymentMethod && values.paymentMethod=='paid_by_driver'?true:false,
              field: (
                <TextField
                  label={'Driver'}
                  placeholder="Driver"
                  name="selectedDriver"
                  variant="outlined"
                  size="small"
                  disabled
                  value={singleTruck && singleTruck.driverId && singleTruck.driverName ? singleTruck.driverName : ''}
                  margin="normal"
                />
              ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Notes</div>
                        <TextField
                            placeholder="Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            rows={3}
                            rowsMax={3}
                            className={classes.textNote}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" className={classes.inputAdornmentV1}> <NotesIcon /></InputAdornment>
                            }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            {addExpensePhoto && addExpensePhoto.length > 0 &&
                                <Grid item>
                                    <div className="S3Uploader-image-margin">
                                        {addExpensePhoto && addExpensePhoto.map((expenseImage, index) => (
                                            <div className="S3Uploader-image-div" key={index}>
                                                {expenseImage.s3Link && <img className="S3Uploader-imagesrc" src={expenseImage.s3Link} alt="fileUpload" />}
                                                <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => { handleDeleteExpensePhoto(index, expenseImage.id) }}></img>
                                            </div>
                                        ))}
                                    </div>
                                </Grid>}
                            <Grid item>
                                <S3Uploader toggle={true} directoryName={"dweb-images/Vehicle/AddDriverExpense"} handleFile={handleAddExpensePhoto} />
                            </Grid>
                        </Grid>
                    </div>

                ),
            },
            {
                size: 12,
                visible:false, //handleDisplayPaidByDriver(values.expenseType),
                field: (
                    <div className={classes.divV4}>
                        <div className={classes.divV5}>Paid by {singleTruck && singleTruck.driverId && singleTruck.driverName ? singleTruck.driverName : 'Driver'}</div>
                        <Switches
                            size='small'
                            margin='normal'
                            formControlProps={{
                                className: classes.switchControl
                            }}
                            onChange={() => { handlePaidByDriver() }}
                            className={classes.switch}
                            name="paidByDriver"
                            data={{ label: '', value: true }} label="" />
                    </div>
                ),
            },
        ]
    }

    return (
        <>
            <Dialog fullWidth={true}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    {edit &&
                        <div className={classes.divV1}>Edit Driver / Other Expense</div>
                    }
                    {!edit &&
                        <div className={classes.divV1}>Add Driver / Other Expense</div>
                    }
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit;
                            setFormError(isEmpty(validate(values)));
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button
                    className={!formError ? classes.disableCta : classes.saveCta}
                    disabled={!formError}
                    type="submit" variant="contained"
                        // onClick={() => {
                        //     document.getElementById('myForm')
                        //         .dispatchEvent(new Event('submit', { cancelable: true }))
                        // }}
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {addDriverDialog && <DriverNameSelect onOpen={addDriverDialog} onClose={handleAddDriverDialogClose} fromSingleTruck={true} onConfirm={handleAddDriverSubmit} driverDetail={driverNameValue} />}
            {addShopOpen && <AddShop open={addShopOpen} defaultName={shopDialogValue.name} defaultNumber={shopDialogValue.number} onClose={handleAddShopClose} onSave={handleShopSave} />}
        </>
    )

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle, user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateVehicleNew: (vehicleId, data, onSuccess, onFailure) => {
        dispatch(
            updateVehicle3(vehicleId, data, onSuccess, onFailure))
    },
    dispatchPhotoAttachmentDelete: (expenseId, attachId, onSuccess, onFailure) => dispatch(DeletePhotoAttachments(expenseId, attachId, onSuccess, onFailure)),
    dispatchUpdateExpenseDetails: (expenseId, data, onSuccess, onFailure) => dispatch(UpdateExpenseDetails(expenseId, data, onSuccess, onFailure)),
    dispacthAddExpenses: (data, onSuccess, onFailure) => dispatch(addVendorExpense(data, onSuccess, onFailure)),
    dispatchAddExpenseTypeDriver: (data, onSuccess, onFailure) => dispatch(AddExpenseTypeDriver(data, onSuccess, onFailure)),
    dispatchDriverExpenseType: (onSuccess, onFailure) => dispatch(DriverExpenseType(onSuccess, onFailure)),
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchAddExpenseV1: (request, onSuccess, onFailure) =>
    dispatch(addExpenseV1(request, onSuccess, onFailure)),
    dispatchGetShopList: (data,onSuccess, onError) => {
        dispatch(shopListForSelection(data,onSuccess, onError))
    },
    dispatchEditExpenseV1: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editExpenseV1(expenseId, request, onSuccess, onFailure))
});
export default connect(mapStateToProps, mapDispatchToProps)(AddDriverExpenseDialog);
